import type { ReactNode } from "react";

export function fieldErrorId(id: string): string {
	return `${id}-error`;
}

export function fieldDescriptionId(id: string): string {
	return `${id}-description`;
}

export function fieldMixedId(id: string): string {
	return `${id}-mixed`;
}

export function ariaInvalidFromError(error?: ReactNode): true | undefined {
	return error ? true : undefined;
}

export function buildControlDescribedBy(options: {
	id: string;
	error?: ReactNode;
	hasDescription?: boolean;
	mixedId?: string;
	extraIds?: Array<string | null | undefined>;
}): string | undefined {
	const parts = [
		options.mixedId,
		options.hasDescription ? fieldDescriptionId(options.id) : null,
		options.error ? fieldErrorId(options.id) : null,
		...(options.extraIds ?? []),
	].filter(Boolean);
	return parts.length > 0 ? parts.join(" ") : undefined;
}
